(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["asp-christmas-countdown"] && !Shopify.designMode) return;
  try {
    (()=>{document.querySelectorAll('[data-christmas-clock]').forEach(root=>{const target=Date.parse(root.dataset.target);if(!Number.isFinite(target))return;function tick(){const left=target-Date.now();if(left<=0){root.querySelector('[data-clock-heading]').textContent=root.querySelector('[data-clock-festive]').textContent;root.querySelector('[data-clock-numbers]').hidden=true;root.querySelector('.asp-countdown-dates').hidden=true;return false;}const total=Math.floor(left/60000);root.querySelector('[data-clock-days]').textContent=Math.floor(total/1440);root.querySelector('[data-clock-hours]').textContent=String(Math.floor(total%1440/60)).padStart(2,'0');root.querySelector('[data-clock-minutes]').textContent=String(total%60).padStart(2,'0');root.querySelector('[data-clock-expired]').hidden=Date.now()<Date.parse('2026-12-07T00:00:00+00:00');return true;}if(tick()){const timer=setInterval(()=>{if(!tick())clearInterval(timer);},60000);}});})();
  } catch(e) { console.error(e); }
})();

})();
